import { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { createSliceWithStateReset } from 'store/createSliceWithStateReset';
import { AppSku, Cobrand, CobrandIdentifier, CobrandMap } from './types';

interface CobrandState {
  // Cobrand as returned from the server (e.g. from /me or /login responses)
  serverCobrandSku: AppSku | undefined;
  // Cobrand as determined by the client (e.g. from URL)
  clientCobrand: Cobrand | undefined;
}

const initialState: CobrandState = {
  serverCobrandSku: undefined,
  clientCobrand: undefined,
};
const cobrandSlice = createSliceWithStateReset({
  name: 'cobrand',
  initialState,
  preserveKeys: ['clientCobrand'],
  reducers: {
    setServerCobrandSku: (state, action: PayloadAction<AppSku | undefined>) => ({
      ...state,
      serverCobrandSku: action.payload,
    }),
    setClientCobrand: (state, action: PayloadAction<CobrandIdentifier>) => ({
      ...state,
      clientCobrand: CobrandMap[action.payload],
    }),
  },
});

export const { setServerCobrandSku, setClientCobrand } = cobrandSlice.actions;

export const { reducer: cobrandReducer } = cobrandSlice;

export const selectServerCobrandSku = (state: RootState) => state.cobrand.serverCobrandSku;

export const selectClientCobrand = (state: RootState) => state.cobrand.clientCobrand;
